<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="对账单ID" prop="pid">
        <el-input v-model="form.pid" placeholder="请输入对账单ID" v-trim/>
      </el-form-item>
      <el-form-item label="交易时间" prop="billDate">
        <el-date-picker v-model="form.billDate" value-format="yyyy-MM-dd" placeholder="请输入交易时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="商户号" prop="mchId">
        <el-input v-model="form.mchId" placeholder="请输入商户号" v-trim/>
      </el-form-item>
      <el-form-item label="微信订单号" prop="transactionId">
        <el-input v-model="form.transactionId" placeholder="请输入微信订单号" v-trim/>
      </el-form-item>
      <el-form-item label="商户订单号" prop="outTradeNo">
        <el-input v-model="form.outTradeNo" placeholder="请输入商户订单号" v-trim/>
      </el-form-item>
      <el-form-item label="用户标识" prop="openid">
        <el-input v-model="form.openid" placeholder="请输入用户标识" v-trim/>
      </el-form-item>
      <el-form-item label="交易类型" prop="billType">
        <el-input v-model="form.billType" placeholder="请输入交易类型" v-trim/>
      </el-form-item>
      <el-form-item label="券核销金额（元）" prop="couponFee">
        <el-input v-model="form.couponFee" placeholder="请输入券核销金额（元）" v-trim/>
      </el-form-item>
      <el-form-item label="退款批次号/请求号" prop="refundId">
        <el-input v-model="form.refundId" placeholder="请输入退款批次号/请求号" v-trim/>
      </el-form-item>
      <el-form-item label="商品名称" prop="body">
        <el-input v-model="form.body" placeholder="请输入商品名称" v-trim/>
      </el-form-item>
      <el-form-item label="手续费" prop="cmmsAmt">
        <el-input v-model="form.cmmsAmt" placeholder="请输入手续费" v-trim/>
      </el-form-item>
      <el-form-item label="订单金额" prop="totalFee">
        <el-input v-model="form.totalFee" placeholder="请输入订单金额" v-trim/>
      </el-form-item>
      <el-form-item label="申请退款金额" prop="applyRefundFee">
        <el-input v-model="form.applyRefundFee" placeholder="请输入申请退款金额" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="商家实收（元）" prop="receipts">
        <el-input v-model="form.receipts" placeholder="请输入商家实收（元）" v-trim/>
      </el-form-item>
      <el-form-item label="支付宝红包（元）" prop="aliRedEnvelope">
        <el-input v-model="form.aliRedEnvelope" placeholder="请输入支付宝红包（元）" v-trim/>
      </el-form-item>
      <el-form-item label="集分宝（元）" prop="jifenbao">
        <el-input v-model="form.jifenbao" placeholder="请输入集分宝（元）" v-trim/>
      </el-form-item>
      <el-form-item label="支付宝优惠（元）" prop="aliOfferFee">
        <el-input v-model="form.aliOfferFee" placeholder="请输入支付宝优惠（元）" v-trim/>
      </el-form-item>
      <el-form-item label="商家优惠（元）" prop="offerFee">
        <el-input v-model="form.offerFee" placeholder="请输入商家优惠（元）" v-trim/>
      </el-form-item>
      <el-form-item label="券名称" prop="couponName">
        <el-input v-model="form.couponName" placeholder="请输入券名称" v-trim/>
      </el-form-item>
      <el-form-item label="商家红包消费金额（元）" prop="redEnvelope">
        <el-input v-model="form.redEnvelope" placeholder="请输入商家红包消费金额（元）" v-trim/>
      </el-form-item>
      <el-form-item label="卡消费金额（元）" prop="cardFee">
        <el-input v-model="form.cardFee" placeholder="请输入卡消费金额（元）" v-trim/>
      </el-form-item>
      <el-form-item label="分润" prop="shareProfit">
        <el-input v-model="form.shareProfit" placeholder="请输入分润" v-trim/>
      </el-form-item>
      <el-form-item label="门店名称" prop="mchName">
        <el-input v-model="form.mchName" placeholder="请输入门店名称" v-trim/>
      </el-form-item>
      <el-form-item label="操作员" prop="opName">
        <el-input v-model="form.opName" placeholder="请输入操作员" v-trim/>
      </el-form-item>
      <el-form-item label="终端号" prop="tty">
        <el-input v-model="form.tty" placeholder="请输入终端号" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaAliBillDetailWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        pid: '',
        billDate: '',
        mchId: '',
        transactionId: '',
        outTradeNo: '',
        openid: '',
        billType: '',
        couponFee: '',
        refundId: '',
        body: '',
        cmmsAmt: '',
        totalFee: '',
        applyRefundFee: '',
        remark: '',
        receipts: '',
        aliRedEnvelope: '',
        jifenbao: '',
        aliOfferFee: '',
        offerFee: '',
        couponName: '',
        redEnvelope: '',
        cardFee: '',
        shareProfit: '',
        mchName: '',
        opName: '',
        tty: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/aliBillDetail',
      'field.id': 'id'
    })
  }
}
</script>
